var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    width: 20,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "building-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff385c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m15.8 2.2h-8.3c-0.9 0-1.7 0.7-1.7 1.6v4.7l-3.9 3.9q-0.2 0.2-0.2 0.4-0.1 0.3 0 0.5 0.1 0.3 0.3 0.4 0.2 0.1 0.5 0.1v4.2q0 0.3 0.2 0.6 0.3 0.2 0.6 0.2h13.4q0.3 0 0.6-0.2 0.2-0.3 0.2-0.6v-14.2c0-0.9-0.7-1.6-1.7-1.6zm-6.6 15h-5v-4.7l2.5-2.5 2.5 2.5zm6.6 0h-5v-3.3q0.3 0 0.5-0.2 0.2-0.1 0.3-0.3 0.1-0.3 0.1-0.5-0.1-0.3-0.3-0.4l-3.9-4v-4.6h8.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m9.2 5.5h1.6v1.7h-1.6zm3.3 0h1.7v1.6h-1.7zm0 3.4h1.7v1.6h-1.7zm0 3.3h1.7v1.7h-1.7zm-6.7 0.8h1.7v1.7h-1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.78b051617b29ab1225cbc536b1a92d75.svg";
export { ForwardRef as ReactComponent };